import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { StatusPanel } from './StatusPanel';
import { Switch, Route, Link } from 'react-router-dom';
import { Menu, Alert } from 'antd';
import LoadingScreen from 'react-loading-screen';
import { PositionsView } from './PositionsView';
import { IndicatorsView } from './IndicatorsView';
import { SettingsView } from './SettingsView';
import { MarketStatus } from './MarketStatus';
import { BalancesView } from './BalancesView';
import { SubscriptionLegacyView } from './SubscriptionLegacyView';
import { PositionHistoryView } from './PositionHistoryView';
import { SignalsView } from './SignalsView';
import { TriggerView } from './TriggerView';
import { AutoDCAView } from './AutoDCAView';
import { PerformanceView } from './PerformanceView';
import { LogsView } from './LogsView';
import { AutoRTView } from './AutoRTView';
import { PositionView } from './PositionView';

@inject('store')
@observer
export class BotView extends Component {
    componentDidMount() {
        this.props.store.botStore.connectToStream(this.props.match.params.id);
        this.props.store.billingStore.getSubscriptions();
        this.props.store.botConfigStore.getConfigurations();
        this.props.store.botStore.marketStore.loadMarket();
        this.marketSync = setInterval(
            () => this.props.store.botStore.marketStore.loadMarket(),
            10000
        );
    }

    componentWillUnmount() {
        clearInterval(this.marketSync);
        this.props.store.botStore.closeStream();
    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        if (nextProps.match.params.id !== this.props.match.params.id) {
            this.props.store.botStore.closeStream();
            this.props.store.botStore.connectToStream(nextProps.match.params.id);
        }
    }

    render() {
        const bot = this.props.store.botStore.currentBot;
        const botConfig = this.props.store.botStore.bots[this.props.match.params.id];
        if (!bot || !this.props.store.strategyStore.strategies.length) {
            return (
                <LoadingScreen
                    loading={!bot}
                    bgColor="#101010"
                    spinnerColor="#854cfb"
                    textColor="#828282"
                >
                    Loading data
                </LoadingScreen>
            );
        }

        const subscription = this.props.store.billingStore.subscriptions.find(
            sub => sub.bot_id === botConfig.pool_id
        );

        const legacySub = this.props.store.botStore.poolBindings[botConfig.pool_id];
        const legacyActive = (legacySub && Date.now() < legacySub.sub_expiry) || false;

        let defaultSelectedKey = 'positions';
        if (this.props.location.pathname.indexOf('positions') >= 0)
            defaultSelectedKey = 'positions';
        if (this.props.location.pathname.indexOf('performance') >= 0)
            defaultSelectedKey = 'performance';
        if (this.props.location.pathname.indexOf('indicators') >= 0)
            defaultSelectedKey = 'indicators';
        if (this.props.location.pathname.indexOf('autodca') >= 0) defaultSelectedKey = 'autodca';
        if (this.props.location.pathname.indexOf('autort') >= 0) defaultSelectedKey = 'autort';
        if (this.props.location.pathname.indexOf('triggers') >= 0) defaultSelectedKey = 'triggers';
        if (this.props.location.pathname.indexOf('signals') >= 0) defaultSelectedKey = 'signals';
        if (this.props.location.pathname.indexOf('balances') >= 0) defaultSelectedKey = 'balances';
        if (this.props.location.pathname.indexOf('logs') >= 0) defaultSelectedKey = 'logs';
        if (this.props.location.pathname.indexOf('settings') >= 0) defaultSelectedKey = 'settings';

        return (
            <Fragment>
                {this.renderMaintenanceBanner()}
                {!subscription && legacyActive ? (
                    <Alert
                        type="error"
                        showIcon
                        message={`This bot is running a legacy subscription which will be cancelled on the 17th January. Please migrate your bot to the new billing system to retain the $35 price.`}
                        banner
                    />
                ) : null}
                <StatusPanel>
                    <Menu mode="horizontal" defaultSelectedKeys={[defaultSelectedKey]}>
                        <Menu.Item key="performance">
                            <Link to={`/a/bot/${bot}/performance`}>Performance</Link>
                        </Menu.Item>
                        <Menu.Item key="positions">
                            <Link to={`/a/bot/${bot}/positions`}>Positions</Link>
                        </Menu.Item>
                        <Menu.Item key="indicators">
                            <Link to={`/a/bot/${bot}/indicators`}>Indicators</Link>
                        </Menu.Item>
                        <Menu.Item key="triggers">
                            <Link to={`/a/bot/${bot}/automation`}>Automation</Link>
                        </Menu.Item>
                        <Menu.Item key="signals">
                            <Link to={`/a/bot/${bot}/signals`}>Signals</Link>
                        </Menu.Item>
                        <Menu.Item key="autodca">
                            <Link to={`/a/bot/${bot}/autodca`}>Auto DCA</Link>
                        </Menu.Item>
                        <Menu.Item key="autort">
                            <Link to={`/a/bot/${bot}/autort`}>Auto RT</Link>
                        </Menu.Item>
                        <Menu.Item key="balances">
                            <Link to={`/a/bot/${bot}/balances`}>Balances</Link>
                        </Menu.Item>
                        <Menu.Item key="logs">
                            <Link to={`/a/bot/${bot}/logs`}>Logs</Link>
                        </Menu.Item>
                        <Menu.Item key="settings">
                            <Link to={`/a/bot/${bot}/settings`}>Settings</Link>
                        </Menu.Item>
                    </Menu>
                </StatusPanel>

                <Switch>
                    <Route exact path="/a/bot/:id/performance" component={PerformanceView} />
                    <Route exact path="/a/bot/:id/positions" component={PositionsView} />
                    <Route exact path="/a/bot/:botId/position/:id" component={PositionView} />
                    <Route path="/a/bot/:id/indicators" component={IndicatorsView} />
                    <Route path="/a/bot/:id/settings" component={SettingsView} />
                    <Route path="/a/bot/:id/balances" component={BalancesView} />
                    <Route
                        path="/a/bot/:id/legacy_subscription"
                        component={SubscriptionLegacyView}
                    />
                    <Route path="/a/bot/:id/history" component={PositionHistoryView} />
                    <Route path="/a/bot/:id/automation" component={TriggerView} />
                    <Route path="/a/bot/:id/autodca" component={AutoDCAView} />
                    <Route path="/a/bot/:id/signals" component={SignalsView} />
                    <Route path="/a/bot/:id/autort" component={AutoRTView} />
                    <Route path="/a/bot/:id/logs" component={LogsView} />
                </Switch>

                <div
                    className="ticker"
                    style={{
                        zIndex: 10,
                        textAlign: 'center',
                        position: 'fixed',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        padding: 5,
                        display: window.screen.width < 500 ? 'none' : 'block'
                    }}
                >
                    <MarketStatus />
                </div>
            </Fragment>
        );
    }

    renderMaintenanceBanner() {
        const bot = this.props.store.botStore.bots[this.props.match.params.id];
        const poolStatus = this.props.store.botStore.poolBindings[bot.pool_id];

        if (poolStatus.status === 'Undergoing Maintenance') {
            return (
                <Alert
                    type="info"
                    showIcon
                    message={`Undergoing Maintenance: Please wait as your bot will reboot shortly.`}
                    banner
                />
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bot/index.js